(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["meg-blog-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('meg-blog-grid')) {
    class MegBlogGrid extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.cards = Array.from(this.querySelectorAll('[data-meg-card]'));
        this.toggle = this.querySelector('[data-meg-toggle]');
        this.status = this.querySelector('[data-meg-status]');
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.handleMediaChange = this.update.bind(this);
        this.handleToggle = this.toggleExpanded.bind(this);

        this.classList.add('is-enhanced');
        this.applyVisibilityRules();

        if (this.toggle) {
          this.toggle.addEventListener('click', this.handleToggle);
        }

        if (this.mediaQuery.addEventListener) {
          this.mediaQuery.addEventListener('change', this.handleMediaChange);
        } else {
          this.mediaQuery.addListener(this.handleMediaChange);
        }
      }

      disconnectedCallback() {
        if (this.toggle) {
          this.toggle.removeEventListener('click', this.handleToggle);
        }

        if (!this.mediaQuery) return;

        if (this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener('change', this.handleMediaChange);
        } else {
          this.mediaQuery.removeListener(this.handleMediaChange);
        }

        this.initialized = false;
      }

      get limit() {
        const value = this.mediaQuery.matches ? this.dataset.mobileLimit : this.dataset.desktopLimit;
        return Math.max(1, Number.parseInt(value, 10) || this.cards.length);
      }

      get expanded() {
        return this.dataset.expanded === 'true';
      }

      applyVisibilityRules() {
        const styleId = `MegBlogGridVisibility-${this.id}`;
        let style = this.querySelector(`#${CSS.escape(styleId)}`);

        if (!style) {
          style = document.createElement('style');
          style.id = styleId;
          this.appendChild(style);
        }

        style.textContent = `
          #${CSS.escape(this.id)}.is-enhanced[data-expanded='false']
          .meg-blog-grid__item:nth-child(n + ${this.limit + 1}) { display: none; }
        `;

        this.update();
      }

      update() {
        this.applyCurrentLimit();

        if (!this.toggle) return;

        const hasMore = this.cards.length > this.limit;
        this.toggle.hidden = !hasMore;

        if (!hasMore) {
          this.dataset.expanded = 'false';
        }

        this.toggle.setAttribute('aria-expanded', String(hasMore && this.expanded));
        this.toggle.textContent = this.expanded
          ? this.dataset.showLessLabel
          : this.dataset.showMoreLabel;

        this.updateStatus();
      }

      applyCurrentLimit() {
        const style = this.querySelector(`#${CSS.escape(`MegBlogGridVisibility-${this.id}`)}`);
        if (!style) return;

        style.textContent = `
          #${CSS.escape(this.id)}.is-enhanced[data-expanded='false']
          .meg-blog-grid__item:nth-child(n + ${this.limit + 1}) { display: none; }
        `;
      }

      toggleExpanded() {
        this.dataset.expanded = String(!this.expanded);
        this.update();
      }

      updateStatus() {
        if (!this.status) return;

        const shown = this.expanded ? this.cards.length : Math.min(this.limit, this.cards.length);
        this.status.textContent = `Showing ${shown} of ${this.cards.length} articles.`;
      }
    }

    customElements.define('meg-blog-grid', MegBlogGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meg-pdf-viewer"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('oiwa-pdf-viewer')) return;

  // A pinned, shared dependency. Only loaded when a connected viewer approaches the viewport.
  const PDFJS_BASE = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@6.3.289/';
  let libraryPromise;
  const loadLibrary = () => {
    if (!libraryPromise) {
      libraryPromise = import(PDFJS_BASE + 'legacy/build/pdf.min.mjs').then((library) => {
        library.GlobalWorkerOptions.workerSrc = PDFJS_BASE + 'legacy/build/pdf.worker.min.mjs';
        return library;
      }).catch((error) => { libraryPromise = null; throw error; });
    }
    return libraryPromise;
  };

  class OiwaPdfViewer extends HTMLElement {
    connectedCallback() {
      if (this.initFrame || this.controller) return;
      this.initFrame = requestAnimationFrame(() => { this.initFrame = null; this.setup(); });
    }

    setup() {
      if (!this.isConnected || !this.dataset.pdfUrl) return;
      this.reader = this.querySelector('[data-reader]');
      if (!this.reader) return;
      this.viewport = this.querySelector('[data-viewport]');
      this.pages = this.querySelector('[data-pages]');
      this.input = this.querySelector('[data-page-input]');
      this.message = this.querySelector('[data-message]');
      this.status = this.querySelector('[data-status]');
      this.searchPanel = this.querySelector('[data-search-panel]');
      this.searchInput = this.querySelector('[data-search-input]');
      this.searchStatus = this.querySelector('[data-search-status]');
      this.dialog = this.querySelector('[data-dialog]');
      this.inlineMount = this.querySelector('[data-inline-mount]');
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.records = [];
      this.zoom = 1;
      this.fitOverride = null;
      this.layoutOverride = null;
      this.appliedLayout = null;
      this.currentPage = 1;
      this.searchGeneration = (this.searchGeneration || 0) + 1;
      this.searchResults = [];
      this.searchIndex = -1;
      this.searchQuery = '';
      this.generation = (this.generation || 0) + 1;
      this.onScreen = true;
      this.rendering = false;
      this.activeRender = null;
      this.activeRecord = null;
      this.queue = [];
      this.pdf = null;
      this.loading = false;
      this.loadFailed = false;
      this.pageWidth = 0;
      this.pages.replaceChildren();
      this.viewport.scrollTop = 0;
      this.viewport.scrollLeft = 0;
      this.message.hidden = false;
      this.status.textContent = 'Loading document…';
      this.viewport.setAttribute('aria-busy', 'true');
      this.querySelector('[data-page-count]').textContent = '—';
      this.input.value = 1;

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-action]');
        if (!button || !this.contains(button) || button.disabled) return;
        const actions = {
          previous: () => this.goToPrevious(),
          next: () => this.goToNext(),
          'zoom-in': () => this.setZoom(this.zoom + .25),
          'zoom-out': () => this.setZoom(this.zoom - .25),
          'fit-page': () => this.setFitMode('fit_page'),
          'fit-width': () => this.setFitMode('fit_width'),
          'reset-zoom': () => this.resetZoom(),
          'toggle-layout': () => this.toggleLayout(),
          'toggle-search': () => this.toggleSearch(),
          'close-search': () => this.closeSearch(),
          'search-submit': () => this.runSearch(),
          'search-previous': () => this.moveSearch(-1),
          'search-next': () => this.moveSearch(1),
          expand: () => this.openDialog(),
          close: () => this.dialog.close(),
          retry: () => this.load(),
          'retry-page': () => {
            const record = this.records[Number(button.dataset.page) - 1];
            if (record) { record.failed = false; this.schedule(); }
          }
        };
        actions[button.dataset.action]?.();
      }, { signal });
      this.input.addEventListener('change', () => this.goToPage(Number(this.input.value)), { signal });
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') { event.preventDefault(); this.goToPage(Number(this.input.value)); }
      }, { signal });
      if (this.searchInput) {
        this.searchInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') { event.preventDefault(); this.runSearch(); }
          if (event.key === 'Escape') { event.preventDefault(); this.closeSearch(); }
        }, { signal });
      }
      this.viewport.addEventListener('scroll', () => this.schedule(), { passive: true, signal });

      if (this.dialog) {
        this.dialog.addEventListener('close', () => this.restoreInline(), { signal });
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, { signal });
        if (typeof this.dialog.showModal !== 'function') this.querySelector('[data-action="expand"]').hidden = true;
      }

      this.resizeObserver = new ResizeObserver(() => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.layout(), 100);
      });
      this.resizeObserver.observe(this.viewport);
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.mobileQuery.addEventListener('change', () => this.layout(), { signal });
      this.visibilityObserver = new IntersectionObserver((entries) => {
        this.onScreen = entries[0].isIntersecting;
        if (this.onScreen) { if (!this.pdf && !this.loadFailed) this.load(); this.schedule(); }
      }, { rootMargin: '400px' });
      this.visibilityObserver.observe(this);
      this.updateControls();
    }

    async load() {
      if (this.loading || this.pdf || !this.controller) return;
      this.loading = true;
      this.loadFailed = false;
      const generation = this.generation;
      this.message.hidden = false;
      this.status.textContent = 'Loading document…';
      this.querySelector('[data-action="retry"]').hidden = true;
      this.viewport.setAttribute('aria-busy', 'true');
      let task;
      try {
        const url = new URL(this.dataset.pdfUrl, window.location.href);
        if (!['https:', 'http:'].includes(url.protocol)) throw new Error('Invalid PDF URL');
        const library = await loadLibrary();
        if (generation !== this.generation || !this.isConnected) return;
        task = library.getDocument({
          url: url.href,
          cMapUrl: PDFJS_BASE + 'cmaps/',
          cMapPacked: true,
          standardFontDataUrl: PDFJS_BASE + 'standard_fonts/',
          wasmUrl: PDFJS_BASE + 'wasm/',
          isEvalSupported: false,
          enableXfa: false,
          // Range fetching is used where the host supports it; scanned PDFs may still load in full.
          disableAutoFetch: true,
          disableStream: true
        });
        this.loadingTask = task;
        const pdf = await task.promise;
        const first = await pdf.getPage(1);
        if (generation !== this.generation || !this.isConnected) { await task.destroy(); return; }
        this.pdf = pdf;
        const firstViewport = first.getViewport({ scale: 1 });
        this.defaultRatio = firstViewport.width / firstViewport.height;
        this.message.hidden = true;
        for (let number = 1; number <= pdf.numPages; number++) {
          const element = document.createElement('div');
          element.className = 'opdf-page';
          element.setAttribute('role', 'group');
          element.setAttribute('aria-label', 'Page ' + number);
          const placeholder = document.createElement('div');
          placeholder.className = 'opdf-page-placeholder';
          placeholder.textContent = 'Page ' + number;
          placeholder.setAttribute('aria-hidden', 'true');
          element.append(placeholder);
          this.records.push({ number, element, placeholder, ratio: this.defaultRatio, renderedWidth: 0 });
        }
        this.buildPageGroups(this.effectiveLayout());
        this.querySelector('[data-page-count]').textContent = pdf.numPages;
        this.input.max = pdf.numPages;
        this.layout();
      } catch (error) {
        if (generation !== this.generation || !this.isConnected) return;
        this.loadFailed = true;
        this.status.textContent = error.name === 'PasswordException'
          ? 'This document is password-protected and cannot be displayed here.'
          : 'The document could not be loaded. Please try again.';
        this.querySelector('[data-action="retry"]').hidden = false;
        this.viewport.setAttribute('aria-busy', 'false');
        if (task) await task.destroy().catch(() => {});
        this.loadingTask = null;
      } finally {
        if (generation === this.generation) { this.loading = false; this.updateControls(); }
      }
    }

    effectiveLayout() {
      if (!this.canUseSpread()) return 'single';
      const requested = this.layoutOverride || this.dataset.desktopLayout;
      return requested === 'spread' ? 'spread' : 'single';
    }

    canUseSpread() {
      const requested = Number(this.dataset.spreadMinWidth) || 1100;
      const minimum = Math.max(750, Math.min(1600, requested));
      return !this.mobileQuery?.matches && (!this.viewport?.clientWidth || this.viewport.clientWidth >= minimum);
    }

    effectiveFitMode() {
      const requested = this.mobileQuery?.matches
        ? this.dataset.mobileFit
        : (this.fitOverride || this.dataset.desktopFit);
      return requested === 'fit_width' ? 'fit_width' : 'fit_page';
    }

    hasSeparateCover() {
      return this.dataset.spreadCover !== 'false';
    }

    buildPageGroups(mode) {
      if (!this.records.length) return;
      const fragment = document.createDocumentFragment();
      const spread = mode === 'spread';
      const separateCover = spread && this.hasSeparateCover();
      let index = 0;
      while (index < this.records.length) {
        const group = document.createElement('div');
        group.className = 'opdf-spread';
        const count = separateCover && index === 0 ? 1 : (spread ? 2 : 1);
        for (let slot = 0; slot < count && index < this.records.length; slot++, index++) {
          group.append(this.records[index].element);
        }
        fragment.append(group);
      }
      this.pages.replaceChildren(fragment);
      this.appliedLayout = mode;
      this.dataset.effectiveLayout = mode;
    }

    spreadStart(page = this.currentPage) {
      const value = Math.max(1, Math.min(this.pdf?.numPages || 1, page));
      if (this.effectiveLayout() !== 'spread') return value;
      if (this.hasSeparateCover()) {
        if (value === 1) return 1;
        return value % 2 === 0 ? value : value - 1;
      }
      return value % 2 === 1 ? value : value - 1;
    }

    goToPrevious() {
      if (!this.pdf) return;
      if (this.effectiveLayout() !== 'spread') return this.goToPage(this.currentPage - 1);
      const start = this.spreadStart();
      const target = this.hasSeparateCover() && start === 2 ? 1 : start - 2;
      this.goToPage(target);
    }

    goToNext() {
      if (!this.pdf) return;
      if (this.effectiveLayout() !== 'spread') return this.goToPage(this.currentPage + 1);
      const start = this.spreadStart();
      const target = this.hasSeparateCover() && start === 1 ? 2 : start + 2;
      this.goToPage(target);
    }

    toggleLayout() {
      if (!this.canUseSpread() || !this.pdf) return;
      const position = this.capturePosition();
      this.layoutOverride = this.effectiveLayout() === 'spread' ? 'single' : 'spread';
      this.zoom = 1;
      this.layout(position);
    }

    setFitMode(mode) {
      if (!this.pdf || !['fit_page', 'fit_width'].includes(mode)) return;
      const position = this.capturePosition();
      this.fitOverride = mode;
      this.zoom = 1;
      this.layout(position);
    }

    resetZoom() {
      if (!this.pdf) return;
      const position = this.capturePosition();
      this.zoom = 1;
      this.layout(position);
    }

    capturePosition() {
      const record = this.records[this.currentPage - 1];
      return record ? {
        page: this.currentPage,
        fraction: (this.viewport.scrollTop - record.element.offsetTop) / record.element.offsetHeight,
        horizontal: this.viewport.scrollLeft / Math.max(1, this.viewport.scrollWidth - this.viewport.clientWidth)
      } : null;
    }

    restorePosition(position) {
      if (!position) return;
      const record = this.records[position.page - 1];
      if (!record) return;
      this.viewport.scrollTop = record.element.offsetTop + position.fraction * record.element.offsetHeight;
      this.viewport.scrollLeft = position.horizontal * Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
    }

    sizing() {
      const read = (key, fallback, min, max) => {
        const raw = this.dataset[key];
        const value = raw == null || raw === '' ? fallback : Number(raw);
        return Math.max(min, Math.min(max, Number.isFinite(value) ? value : fallback));
      };
      const mobile = this.mobileQuery?.matches;
      const computedSpreadGap = parseFloat(getComputedStyle(this).getPropertyValue('--opdf-spread-gap'));
      return {
        fraction: read(mobile ? 'mobilePageWidth' : 'desktopPageWidth', 100, mobile ? 60 : 40, 100) / 100,
        gutter: read(mobile ? 'mobileGutter' : 'desktopGutter', 16, 0, 48),
        maxWidth: read('pageMaxWidth', 1100, 500, 1600),
        spreadGap: Number.isFinite(computedSpreadGap) ? computedSpreadGap : 12
      };
    }

    layout(position = this.capturePosition()) {
      if (!this.pdf || !this.controller || !this.viewport.clientWidth) return;
      const mode = this.effectiveLayout();
      if (mode !== this.appliedLayout) this.buildPageGroups(mode);
      const fitMode = this.effectiveFitMode();
      const { fraction, gutter, maxWidth, spreadGap } = this.sizing();
      const columns = mode === 'spread' ? 2 : 1;
      const availableWidth = Math.max(100, this.viewport.clientWidth - gutter * 2 - (columns - 1) * spreadGap);
      const widthFit = Math.min(maxWidth, availableWidth / columns * fraction);
      const spreadStart = this.spreadStart();
      const visibleRatios = [this.records[spreadStart - 1]?.ratio || this.defaultRatio];
      if (mode === 'spread' && this.records[spreadStart]) visibleRatios.push(this.records[spreadStart].ratio || this.defaultRatio);
      const limitingRatio = Math.min(...visibleRatios);
      const heightFit = Math.max(100, this.viewport.clientHeight - gutter * 2) * limitingRatio;
      const fittedWidth = fitMode === 'fit_page' ? Math.min(widthFit, heightFit) : widthFit;
      const width = Math.max(100, Math.floor(fittedWidth * this.zoom));
      const contentWidth = width * columns + (columns - 1) * spreadGap + gutter * 2;
      this.pages.style.setProperty('--opdf-content-width', Math.ceil(contentWidth) + 'px');
      this.dataset.effectiveFit = fitMode;
      if (width !== this.pageWidth) {
        this.pageWidth = width;
        this.pages.style.setProperty('--opdf-page-width', width + 'px');
        this.records.forEach((record) => { record.element.style.height = width / record.ratio + 'px'; });
        if (this.activeRender) this.activeRender.cancel();
      }
      this.restorePosition(position);
      this.updateControls();
      this.schedule();
    }

    setZoom(value) {
      if (!this.pdf) return;
      const position = this.capturePosition();
      this.zoom = Math.max(.5, Math.min(2.5, Math.round(value * 4) / 4));
      this.layout(position);
    }

    goToPage(value) {
      if (!this.pdf) return;
      const page = Math.max(1, Math.min(this.pdf.numPages, Math.round(value) || 1));
      this.currentPage = page;
      this.input.value = this.effectiveLayout() === 'spread' ? this.spreadStart(page) : page;
      if (this.effectiveFitMode() === 'fit_page') this.layout(null);
      this.viewport.scrollTop = Math.max(0, this.records[page - 1].element.offsetTop - this.sizing().gutter);
      this.updateControls();
      this.schedule();
    }

    updateControls() {
      const ready = Boolean(this.pdf);
      this.querySelectorAll('[data-document-control]').forEach((control) => { control.disabled = !ready; });
      if (ready) {
        const spreadStart = this.spreadStart();
        this.querySelector('[data-action="previous"]').disabled = spreadStart <= 1;
        this.querySelector('[data-action="next"]').disabled = this.effectiveLayout() === 'spread'
          ? (this.hasSeparateCover() && spreadStart === 1
            ? this.pdf.numPages <= 1
            : spreadStart + 1 >= this.pdf.numPages)
          : this.currentPage >= this.pdf.numPages;
        this.querySelector('[data-action="zoom-out"]').disabled = this.zoom <= .5;
        this.querySelector('[data-action="zoom-in"]').disabled = this.zoom >= 2.5;
        this.querySelector('[data-action="reset-zoom"]').disabled = this.zoom === 1;
        const displayPage = this.effectiveLayout() === 'spread' ? spreadStart : this.currentPage;
        const rangeEnd = this.effectiveLayout() === 'spread' ? Math.min(this.pdf.numPages, spreadStart + 1) : displayPage;
        if (document.activeElement !== this.input) this.input.value = displayPage;
        this.input.setAttribute('aria-label', this.effectiveLayout() === 'spread' ? 'First page in the displayed spread' : 'Page number');
        this.querySelector('[data-page-range-end]').textContent = rangeEnd > displayPage ? `–${rangeEnd}` : '';
      }
      const layoutButton = this.querySelector('[data-action="toggle-layout"]');
      if (layoutButton) {
        const spread = this.effectiveLayout() === 'spread';
        layoutButton.hidden = !this.canUseSpread();
        layoutButton.setAttribute('aria-pressed', String(spread));
        layoutButton.setAttribute('aria-label', spread ? 'Two-page view enabled' : 'Enable two-page view');
        layoutButton.title = spread ? 'Switch to single-page view' : 'Switch to two-page view';
      }
      const fitMode = this.effectiveFitMode();
      const fitPageButton = this.querySelector('[data-action="fit-page"]');
      const fitWidthButton = this.querySelector('[data-action="fit-width"]');
      fitPageButton?.setAttribute('aria-pressed', String(ready && fitMode === 'fit_page' && this.zoom === 1));
      fitWidthButton?.setAttribute('aria-pressed', String(ready && fitMode === 'fit_width' && this.zoom === 1));
      const previousMatch = this.querySelector('[data-action="search-previous"]');
      const nextMatch = this.querySelector('[data-action="search-next"]');
      if (previousMatch) previousMatch.disabled = this.searchResults.length < 2;
      if (nextMatch) nextMatch.disabled = this.searchResults.length < 2;
      this.querySelector('[data-zoom-label]').textContent = Math.round(this.zoom * 100) + '%';
    }

    toggleSearch() {
      if (!this.searchPanel || !this.searchInput) return;
      const opening = this.searchPanel.hidden;
      this.searchPanel.hidden = !opening;
      this.querySelector('[data-action="toggle-search"]')?.setAttribute('aria-expanded', String(opening));
      if (opening) this.searchInput.focus({ preventScroll: true });
      else this.closeSearch();
    }

    closeSearch() {
      if (!this.searchPanel) return;
      this.searchPanel.hidden = true;
      this.querySelector('[data-action="toggle-search"]')?.setAttribute('aria-expanded', 'false');
      this.searchGeneration++;
      this.clearSearchHighlight();
      this.querySelector('[data-action="toggle-search"]')?.focus({ preventScroll: true });
    }

    clearSearchHighlight() {
      this.records.forEach((record) => record.element.classList.remove('is-search-result'));
    }

    async runSearch() {
      if (!this.pdf || !this.searchInput || !this.searchStatus) return;
      const query = this.searchInput.value.trim().replace(/\s+/g, ' ').toLocaleLowerCase();
      if (!query) {
        this.searchStatus.textContent = 'Enter a word or phrase.';
        this.searchInput.focus({ preventScroll: true });
        return;
      }
      const token = ++this.searchGeneration;
      this.searchQuery = query;
      this.searchResults = [];
      this.searchIndex = -1;
      this.clearSearchHighlight();
      this.updateControls();
      let searchableCharacters = 0;
      for (let index = 0; index < this.records.length; index++) {
        if (token !== this.searchGeneration || !this.controller) return;
        const record = this.records[index];
        if (record.searchText == null) {
          try {
            const page = record.proxy || await this.pdf.getPage(record.number);
            const text = await page.getTextContent();
            record.searchText = text.items.map((item) => item.str || '').join(' ').replace(/\s+/g, ' ').toLocaleLowerCase();
          } catch (error) {
            record.searchText = '';
          }
        }
        searchableCharacters += record.searchText.length;
        if (record.searchText.includes(query)) this.searchResults.push(record);
        if (index === 0 || (index + 1) % 10 === 0 || index + 1 === this.records.length) {
          this.searchStatus.textContent = `Searching page ${index + 1} of ${this.records.length}…`;
          await new Promise((resolve) => requestAnimationFrame(resolve));
        }
      }
      if (token !== this.searchGeneration || !this.controller) return;
      if (!searchableCharacters) {
        this.searchStatus.textContent = 'No searchable text was found. This PDF may contain scanned images without OCR.';
      } else if (!this.searchResults.length) {
        this.searchStatus.textContent = `No matching pages for “${this.searchInput.value.trim()}”.`;
      } else {
        this.searchIndex = 0;
        this.showSearchResult();
      }
      this.updateControls();
    }

    moveSearch(direction) {
      if (!this.searchResults.length) return;
      this.searchIndex = (this.searchIndex + direction + this.searchResults.length) % this.searchResults.length;
      this.showSearchResult();
    }

    showSearchResult() {
      const record = this.searchResults[this.searchIndex];
      if (!record) return;
      this.clearSearchHighlight();
      record.element.classList.add('is-search-result');
      this.searchStatus.textContent = `${this.searchIndex + 1} of ${this.searchResults.length} matching pages — page ${record.number}`;
      this.goToPage(record.number);
    }

    schedule() {
      if (this.scrollFrame || !this.controller) return;
      this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.refresh(); });
    }

    refresh() {
      if (!this.pdf || !this.controller || (!this.onScreen && !this.dialog?.open)) return;
      const top = this.viewport.scrollTop;
      const height = this.viewport.clientHeight;
      if (!height) return;
      let best = 0;
      let page = this.currentPage;
      // Keep only visible pages and a short buffer. No full-document canvas allocation.
      const nearby = [];
      for (const record of this.records) {
        const start = record.element.offsetTop;
        const end = start + record.element.offsetHeight;
        const visible = Math.max(0, Math.min(end, top + height) - Math.max(start, top));
        if (visible > best) { best = visible; page = record.number; }
        if (end >= top - height && start <= top + height * 2) nearby.push(record);
      }
      this.currentPage = page;
      this.updateControls();
      nearby.sort((a, b) => Math.abs(a.number - page) - Math.abs(b.number - page));
      const retained = new Set(nearby.slice(0, 8));
      for (const record of this.records) {
        if (!retained.has(record) && record.canvas && record !== this.activeRecord) this.releaseCanvas(record);
      }
      this.queue = nearby.slice(0, 8).filter((record) => record.renderedWidth !== this.pageWidth && !record.failed);
      if (this.activeRecord && !retained.has(this.activeRecord) && this.activeRender) this.activeRender.cancel();
      this.renderNext();
    }

    releaseCanvas(record) {
      if (!record.canvas) return;
      record.canvas.width = 0;
      record.canvas.height = 0;
      record.canvas.remove();
      record.canvas = null;
      record.renderedWidth = 0;
      record.placeholder.hidden = false;
      record.proxy?.cleanup();
      record.proxy = null;
    }

    async renderNext() {
      if (this.rendering || !this.queue?.length || !this.pdf) return;
      const record = this.queue.shift();
      const generation = this.generation;
      const width = this.pageWidth;
      const pdf = this.pdf;
      this.rendering = true;
      this.activeRecord = record;
      let canvas;
      try {
        const page = await pdf.getPage(record.number);
        if (generation !== this.generation || !this.controller || width !== this.pageWidth) return;
        record.proxy = page;
        record.placeholder.textContent = 'Loading page ' + record.number + '…';
        record.placeholder.setAttribute('aria-hidden', 'true');
        const unit = page.getViewport({ scale: 1 });
        const ratio = unit.width / unit.height;
        if (Math.abs(ratio - record.ratio) > .001) {
          const position = this.capturePosition();
          record.ratio = ratio;
          record.element.style.height = this.pageWidth / ratio + 'px';
          this.restorePosition(position);
        }
        const viewport = page.getViewport({ scale: width / unit.width });
        // Cap canvas memory and dimensions, particularly for Safari and large scanned manuals.
        const outputScale = Math.min(window.devicePixelRatio || 1, 2, 4096 / viewport.width, 4096 / viewport.height, Math.sqrt(6000000 / (viewport.width * viewport.height)));
        canvas = document.createElement('canvas');
        canvas.setAttribute('aria-hidden', 'true');
        canvas.width = Math.max(1, Math.floor(viewport.width * outputScale));
        canvas.height = Math.max(1, Math.floor(viewport.height * outputScale));
        const context = canvas.getContext('2d', { alpha: false });
        this.activeRender = page.render({ canvasContext: context, viewport, transform: [outputScale, 0, 0, outputScale, 0, 0], annotationMode: 0 });
        await this.activeRender.promise;
        if (generation !== this.generation || !this.controller || width !== this.pageWidth) return;
        if (record.canvas) { record.canvas.width = 0; record.canvas.height = 0; record.canvas.remove(); }
        record.canvas = canvas;
        record.element.append(canvas);
        record.renderedWidth = width;
        record.placeholder.hidden = true;
        this.viewport.setAttribute('aria-busy', 'false');
        // Provide extracted text to assistive technology where the PDF contains it.
        if (!record.text) {
          const text = await page.getTextContent().catch(() => ({ items: [] }));
          if (generation !== this.generation || !this.controller) return;
          if (record.searchText == null) record.searchText = text.items.map((item) => item.str || '').join(' ').replace(/\s+/g, ' ').toLocaleLowerCase();
          const accessibleText = document.createElement('div');
          accessibleText.className = 'opdf-sr-only';
          accessibleText.textContent = text.items.map((item) => item.str ? item.str + (item.hasEOL ? '\n' : ' ') : '').join('') || 'Scanned page. No embedded text is available.';
          record.element.append(accessibleText);
          record.text = accessibleText;
        }
      } catch (error) {
        if (generation !== this.generation || !this.controller) return;
        if (error.name !== 'RenderingCancelledException') {
          record.failed = true;
          record.placeholder.replaceChildren(document.createTextNode('Page ' + record.number + ' could not be displayed.'));
          record.placeholder.removeAttribute('aria-hidden');
          const retry = document.createElement('button');
          retry.type = 'button';
          retry.className = 'opdf-button opdf-page-retry';
          retry.dataset.action = 'retry-page';
          retry.dataset.page = record.number;
          retry.textContent = 'Retry page ' + record.number;
          record.placeholder.append(retry);
          record.placeholder.hidden = false;
          this.viewport.setAttribute('aria-busy', 'false');
        }
      } finally {
        if (canvas && canvas !== record.canvas) { canvas.width = 0; canvas.height = 0; }
        if (generation === this.generation) {
          this.activeRender = null;
          this.activeRecord = null;
          this.rendering = false;
          this.schedule();
        }
      }
    }

    openDialog() {
      if (!this.dialog || this.dialog.open || !this.controller) return;
      const position = this.capturePosition();
      this.returnFocus = document.activeElement;
      this.inlineMount.style.height = this.reader.getBoundingClientRect().height + 'px';
      this.bodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
      this.querySelector('[data-dialog-mount]').append(this.reader);
      this.layout(position);
      this.querySelector('[data-action="close"]').focus({ preventScroll: true });
      this.load();
    }

    restoreInline() {
      if (this.reader.parentElement === this.inlineMount) return;
      const position = this.capturePosition();
      this.inlineMount.append(this.reader);
      this.inlineMount.style.height = '';
      document.body.style.overflow = this.bodyOverflow ?? '';
      this.bodyOverflow = undefined;
      this.layout(position);
      if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.initFrame = null;
      if (!this.controller) return;
      this.generation++;
      this.searchGeneration++;
      if (this.dialog?.open) { this.dialog.close(); this.restoreInline(); }
      this.controller.abort();
      this.controller = null;
      this.visibilityObserver.disconnect();
      this.resizeObserver.disconnect();
      clearTimeout(this.resizeTimer);
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = null;
      this.activeRender?.cancel();
      this.records.forEach((record) => { if (record.canvas) { record.canvas.width = 0; record.canvas.height = 0; } });
      this.loadingTask?.destroy().catch(() => {});
      this.loadingTask = null;
      this.pdf = null;
    }
  }
  customElements.define('oiwa-pdf-viewer', OiwaPdfViewer);
})();

  } catch(e) { console.error(e); }
})();
})();
